export enum ActionTypes {
  SET_SOCIAL_ACCOUNTS = '@mentionedListPage/SET_SOCIAL_ACCOUNTS',
}

import { IBrand } from 'src/common/models/brand';
import { ICampaign } from 'src/common/models/campaign';
import { IOrganization } from 'src/common/models/organization';
import { ISocialAccount } from 'src/common/models/socialAccount';

/**
 * Action.
 */
export interface IMentionedListPageAction {
  type: ActionTypes;
  payload?: {
    count?: number;
    socialAccounts?: ISocialAccount[];
  };
}

/* States */
export interface IMentionedListPage {
  // endpoints
  apiEndpoint: string;
  // brand id and campaign id
  brand: IBrand;
  campaign: ICampaign;
  org: IOrganization;
  isQa: boolean;

  // social accounts and total count
  count: number;
  socialAccounts: ISocialAccount[];
}

/**
 * Initial state.
 */
export const initialState: IMentionedListPage = {
  apiEndpoint: null,
  brand: null,
  campaign: null,
  org: null,
  isQa: false,

  count: 0,
  socialAccounts: [],
};
